import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'

import IndeterminateCheckbox from '../../../ui/components/documentsTable/components/indeterminateCheckbox'
import { StyledCategory } from './documents.styles'
import { Document } from '../../../domain/documents.types'
import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'

const columnHelper = createColumnHelper<Document>()

// column id are similar to database column names for sorting columns except for powerPlantName witch corresponds to a join table column

const useDocumentsTablesColumnsHelper = () => {
  const { t } = useCustomTranslation('common')

  return [
    {
      id: 'select',
      header: ({
        table,
      }: {
        table: import('@tanstack/react-table').Table<Document>
      }): React.ReactNode =>
        IndeterminateCheckbox({
          checked: table.getIsAllRowsSelected(),
          indeterminate: table.getIsSomeRowsSelected(),
          onChange: table.getToggleAllRowsSelectedHandler(),
        }),
      cell: ({ row }: { row: import('@tanstack/react-table').Row<Document> }): React.ReactNode =>
        IndeterminateCheckbox({
          checked: row.getIsSelected(),
          disabled: !row.getCanSelect(),
          indeterminate: row.getIsSomeSelected(),
          onChange: row.getToggleSelectedHandler(),
        }),
    },
    columnHelper.accessor('displayName', {
      id: 'displayName',
      header: t('titled'),
      cell: (info) => info.getValue(),
      enableGlobalFilter: true,
      sortDescFirst: true,
      meta: {
        textAlign: 'left',
      },
    }),
    columnHelper.accessor('powerPlantName', {
      id: 'powerPlantName',
      cell: (info) => info.getValue(),
      header: t('powerplant'),
      enableGlobalFilter: true,
      enableSorting: true,
      sortDescFirst: true,
      meta: {
        textAlign: 'left',
      },
    }),
    columnHelper.accessor('reportType', {
      id: 'reportType',
      header: t('category'),
      cell: (info) => {
        return <StyledCategory color={info.getValue()}>{info.getValue()}</StyledCategory>
      },
      enableGlobalFilter: false,
      sortDescFirst: true,
      meta: {
        textAlign: 'center',
      },
    }),
    columnHelper.accessor('publishedAt', {
      id: 'publishedAt',
      cell: (info) => format(info.getValue(), 'dd MMMM yyyy', { locale: fr }),
      header: t('date'),
      enableGlobalFilter: false,
      enableSorting: true,
      meta: {
        textAlign: 'center',
      },
    }),
    columnHelper.accessor('size', {
      id: 'size',
      cell: (info) => `${Math.round(info.getValue() / 1000)} ko`,
      header: t('size'),
      enableGlobalFilter: false,
      meta: {
        textAlign: 'center',
      },
    }),
    columnHelper.accessor('documentType', {
      id: 'documentType',
      cell: (info) => info.getValue().toUpperCase(),
      header: t('type'),
      enableGlobalFilter: false,
      enableSorting: false,
      meta: {
        textAlign: 'center',
      },
    }),
    columnHelper.display({
      id: 'action',
      header: t('actions'),
      enableGlobalFilter: false,
      enableSorting: false,
      meta: {
        textAlign: 'center',
      },
    }),
  ]
}

export default useDocumentsTablesColumnsHelper
